<template>
  <svg viewBox="0 0 1562 1873" v-on="$listeners">
    <path
      d="M0 781q0-159 62-304t167-249T478.5 62T781 0q159 0 303.5 62t249 166.5t166.5 249t62 303.5q0 259-153.5 462.5T1013 1522v351H561v-347q-247-72-404-278T0 781zm172 0q0 248 180 426q178 179 429 179q165 0 305.5-81t222.5-220.5t82-303.5q0-123-48.5-235.5t-130.5-194t-195-130T781 173t-235.5 48.5t-194.5 130t-130.5 194T172 781zm62 38v-77h231v77H234zm116-377l56-55l162 162l-55 56zm270 526q0-67 46.5-116T780 801l291-479l70 37l-215 515q28 40 28 94q0 70-49 118.5T786 1135q-69 0-117.5-48.5T620 968zm140-498V239h74v231h-74zm313 348v-79h231v79h-231z"
      fill="currentColor"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'meter-icon',
}
</script>